'use client';
import { TypeButton, TypePageJournal } from '@fm-nx/contentful-types';
import Slideshow from '../slideshow/slideshow';
import useSWRImmutable from 'swr/immutable';
import { fetcher } from '@fm-nx/contentful';

export interface SlideshowJournalProps {
    overline?: string;
    headerText?: string;
    button?: TypeButton<'WITHOUT_UNRESOLVABLE_LINKS'>;
    solutionId?: string;
    technologyId?: string;
    serviceId?: string;
    companyTopicId?: string;
    industryId?: string;
    authorPageId?: string;
    excludeId?: string;
}

export function SlideshowJournal(props: SlideshowJournalProps) {
    const {
        overline = 'Journal',
        headerText = 'Here are some other articles you might like.',
        button,
        solutionId,
        technologyId,
        serviceId,
        companyTopicId,
        industryId,
        authorPageId,
        excludeId,
    } = props;
    const searchParams = new URLSearchParams(`limit=6`);
    if (solutionId) searchParams.append('solutionId', solutionId);
    if (technologyId) searchParams.append('technologyId', technologyId);
    if (serviceId) searchParams.append('serviceId', serviceId);
    if (companyTopicId) searchParams.append('companyTopicId', companyTopicId);
    if (industryId) searchParams.append('industryId', industryId);
    if (authorPageId) searchParams.append('authorPageId', authorPageId);
    if (excludeId) searchParams.append('excludeId', excludeId);

    const url = `/api/journal?${searchParams.toString()}`;

    // TODO: remove current journal
    const { data } = useSWRImmutable<TypePageJournal<'WITHOUT_UNRESOLVABLE_LINKS'>[]>(url, fetcher);

    if (!data || data.length === 0) return null;

    return (
        <Slideshow
            overline={overline}
            headerText={headerText}
            button={
                button
                    ? button
                    : ({
                          fields: {
                              buttonText: `Explore all Articles`,
                              linkPath: `/about/journal`,
                          },
                      } as TypeButton<'WITHOUT_UNRESOLVABLE_LINKS'>)
            }
            pages={data}
        />
    );
}

export default SlideshowJournal;
